import React, { ReactNode } from "react"
import classNames from "classnames"
import { IAppState } from "../../../../app/appTypes"
import { MockStore } from "redux-mock-store"
import { getAssetById } from "../../../../shared/selectors/asset"
import { IconTask } from "../../../../svg/icons"
import { IMeetingCaseAsset } from "../../../meetingCase/state/meetingCaseTypes"
import { useSelector } from "react-redux"
import { FormState, IFormAsset } from "../../state/assetsTypes"
import AssetSubHeader from "./AssetSubHeading"
import CaseAssetLabel from "./CaseAssetLabel"
import { useTranslation } from "react-i18next"
import LoadingSpinnerSmall from "../../../../shared/components/ui/LoadingSpinnerSmall"

interface Props {
  store?: MockStore
  assetId: string
  action?: () => void
  isSelected?: boolean
  meetingCaseAsset?: IMeetingCaseAsset
  meetingId?: string
  children?: ReactNode
  noAction?: boolean
  liveMeeting?: boolean
}

const Form: React.FC<Props> = (props: Props): JSX.Element => {
  const asset = useSelector((state: IAppState) => getAssetById(state, props))
  const form = asset.asset as IFormAsset
  const { t } = useTranslation(["asset"])
  const isDraft = form.state != FormState.complete
  const isPendingPdfDownload = form.state == FormState.complete && !form.path
  const isClickable =  !props.noAction && props.action &&  (isDraft || !isPendingPdfDownload) && !(isDraft && props.liveMeeting)
  return (
    <div
      onClick={isClickable ? () => props.action() : null}
      className={classNames(
        "bg-white p-2 flex rounded-md border-2",
        {
          "border-ch-blue-200": !props.isSelected,
          "border-ch-blue-500": props.isSelected,
          "hover:border-ch-blue-500": isClickable,
          "cursor-pointer": isClickable,
          "cursor-default": !isClickable,
        }
      )}
    >
      <div className="text-ch-purple-500 mr-2 mt-1">
        <IconTask className="w-5 h-5" title={form.name} />
      </div>
      <div className="flex-1">
        <div className="flex">
          <h4 className="font-semibold text-lg flex-1">
            {form.name}
          </h4>
          <CaseAssetLabel isVisible={isDraft}>
            {t("asset:draft")}
          </CaseAssetLabel>
          <CaseAssetLabel isVisible={isPendingPdfDownload}>
            {t("asset:generatingForm")}
            <LoadingSpinnerSmall />
          </CaseAssetLabel>
        </div>
        <AssetSubHeader
          meetingCaseAsset={props.meetingCaseAsset}
          meetingId={props.meetingId}
          asset={asset} />
        <p >
          {form.description}
        </p>
      </div>
      {props.children}
    </div>
  )
}

export default Form
